import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';


export default compose(
  withState('confirmationState', 'setConfirmationState', ''),

  withHandlers({
    beginConfirmation: ({ setConfirmationState }) => (e) => {
      setConfirmationState(e.currentTarget.name);
    },
    stopConfirmation: ({ setConfirmationState }) => () => {
      setConfirmationState('');
    },
  })
);
